import React from "react";
import ReactDOM from "react-dom";
import SSOBulkUpload from "./SSOBulkUpload.jsx";

export function initSSOBulkUpload() {
  document.querySelectorAll(".js-sso-bulk-upload").forEach((mount, i) => {
    ReactDOM.render(<SSOBulkUpload />, mount);
  });
}
